import PageHeader from "@/components/shared/PageHeader";
import CTABlock from "@/components/shared/CTABlock";

const PRINCIPLES = [
  {
    n: "01",
    title: "Music-first, always.",
    body: "We built Prulo because most influencer agencies were built for beauty and DTC. Music behaves differently, songs live and die on velocity, cadence and cultural resonance.",
  },
  {
    n: "02",
    title: "The old playbook is over.",
    body: "Traditional influencer marketing is one-shot, one-post, one-metric. Music needs a marketing engine, sustained, layered, and measurable at every stage of a release.",
  },
  {
    n: "03",
    title: "Data or it didn't happen.",
    body: "Every recommendation we make is backed by campaign data. Every campaign we run is instrumented so labels see what's working and what isn't in real time.",
  },
  {
    n: "04",
    title: "Built for the enterprise era of music.",
    body: "Labels, management teams, and DSPs need infrastructure, not just campaigns. Prulo is architected to become the operating system for how music gets marketed.",
  },
];

export default function About() {
  return (
    <div data-testid="page-about">
      <PageHeader
        eyebrow="About"
        title="We're building the operating system for music marketing."
        description="Prulo exists because the tools, taxonomies, and playbooks the music industry relies on to break new music were built for another era. We're rebuilding them."
      />

      <section className="py-12 md:py-16 border-b border-white/5">
        <div className="mx-auto max-w-6xl px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          {PRINCIPLES.map((p) => (
            <div key={p.n} className="border border-white/10 rounded-3xl p-8 md:p-10" data-testid={`about-principle-${p.n}`}>
              <div className="text-xs font-mono text-zinc-500">{p.n}</div>
              <h3 className="mt-4 font-display font-semibold text-2xl md:text-3xl tracking-tight">{p.title}</h3>
              <p className="mt-4 text-zinc-400 leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="mx-auto max-w-4xl px-6 md:px-10">
          <div className="text-xs uppercase tracking-[0.24em] text-zinc-500 mb-6">Vision</div>
          <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl tracking-tight text-balance">
            The company labels think of first, when they launch new music.
          </h2>
          <p className="mt-8 text-zinc-400 text-lg leading-relaxed max-w-3xl">
            We're building toward a future where every new release is supported by an intelligent
            marketing layer: creator networks, live campaign analytics, A&R tools, artist discovery,
            and AI campaign planning, all connected. Prulo is starting as the agency labels trust,
            and evolving into the platform they run on.
          </p>
        </div>
      </section>

      <CTABlock />
    </div>
  );
}
